import { type Permission, PermissionAction } from '@tundr/permissions';
import { HrPermission } from '../../../../core/config/hr.types.ts';

export const HR_ROLES_WRITE_PERMISSION: Permission = {
  permission: HrPermission.ROLES,
  action: PermissionAction.WRITE,
};
